import { Input } from '@/components/ui/input';
import { formatBp } from '../utils/vitals';

const FIELDS = [
  { k: 'bp', label: 'BP mmHg', ph: '120/80', span: 'col-span-2', mode: 'decimal' },
  { k: 'pr', label: 'PR /min', ph: '72', mode: 'numeric' },
  { k: 'spo2', label: 'SpO₂ %', ph: '98', mode: 'numeric' },
  { k: 'temp', label: 'Temp °F', ph: '98.6', mode: 'decimal' },
  { k: 'weight', label: 'Wt kg', ph: '12.5', mode: 'decimal' },
];

export const VitalsEditGrid = ({ values, onChange, onFever, testId }) => (
  <div className="grid grid-cols-6 gap-1.5" data-testid={testId}>
    {FIELDS.map((f) => (
      <div key={f.k} className={`space-y-0.5 ${f.span || ''}`}>
        <span className="text-[10px] text-slate-500">{f.label}</span>
        <Input
          type="text"
          inputMode={f.mode}
          placeholder={f.ph}
          value={values[f.k]}
          data-testid={`edit-vital-${f.k}-input`}
          onChange={(e) => {
            let v = e.target.value;
            if (f.k === 'bp') v = formatBp(v);
            if (f.k === 'weight') v = v.replace(/[^0-9.]/g, '').replace(/^(\d*\.\d?).*$/, '$1');
            if (f.k === 'temp' && parseFloat(v) > 100 && onFever) onFever();
            onChange({ ...values, [f.k]: v });
          }}
          className="h-8 text-sm px-2"
        />
      </div>
    ))}
  </div>
);
